/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import { favoriteNotificationTimeout } from 'src/shared/app/market/settings/marketSettings';
import Notification from 'src/shared/app/notification/component/Notification';
import messages from 'src/shared/app/notification/l10n/notificationL10n';

type Props = {
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const MarketFavoriteNotificationDumb = (props: Props): React.Node => {
  const { handleDismiss, intl } = props;

  return (
    <Notification
      timeout={favoriteNotificationTimeout}
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.firstTimeFavorite)}
    </Notification>
  );
};

export default compose(injectIntl)(MarketFavoriteNotificationDumb);
